import { useState } from "react";

// Pendant la saisie, les flèches enregistrent la valeur dans l'état local du
// tableau puis ouvrent immédiatement la cellule éditable voisine.
export const navigateToEditableCellOnArrow = (params: any): boolean => {
  if (!params.editing) return false;

  const keyboardEvent = params.event as KeyboardEvent;
  const { key } = keyboardEvent;
  if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(key)) {
    return false;
  }

  const api = params.api;
  const currentRowIndex = params.node?.rowIndex;
  const currentColumn = params.column;
  if (currentRowIndex === null || currentRowIndex === undefined || !currentColumn) {
    return false;
  }

  let targetRowIndex = currentRowIndex;
  let targetColumn = currentColumn;

  if (key === "ArrowUp" || key === "ArrowDown") {
    targetRowIndex += key === "ArrowUp" ? -1 : 1;
    if (targetRowIndex < 0 || targetRowIndex >= api.getDisplayedRowCount()) {
      return false;
    }
  } else {
    const displayedColumns = api.getAllDisplayedColumns();
    const direction = key === "ArrowLeft" ? -1 : 1;
    let columnIndex = displayedColumns.indexOf(currentColumn) + direction;

    while (columnIndex >= 0 && columnIndex < displayedColumns.length) {
      const candidate = displayedColumns[columnIndex];
      const editable = candidate.getColDef().editable;
      if (editable === true || typeof editable === "function") {
        targetColumn = candidate;
        break;
      }
      columnIndex += direction;
    }

    if (targetColumn === currentColumn) return false;
  }

  keyboardEvent.preventDefault();
  api.stopEditing();
  window.requestAnimationFrame(() => {
    api.ensureIndexVisible(targetRowIndex);
    api.setFocusedCell(targetRowIndex, targetColumn);
    api.startEditingCell({ rowIndex: targetRowIndex, colKey: targetColumn });
  });
  return true;
};

const EditableCellRenderer = (props: any) => {
  const [hovered, setHovered] = useState(false);

  const noteObj = props.data.notes?.find(
    (n: any) => n.EvaluationLevel?.Evaluation?.id === props.colDef.evaluationId,
  );

  const pendingState = noteObj?.__pendingCreate
    ? "new"
    : noteObj?.__pendingDelete
      ? "deleted"
      : noteObj?.__pendingUpdate
        ? "updated"
        : undefined;
  const stateStyles: Record<string, { background: string; border: string; label: string; color: string }> = {
    new: { background: "#e8f7ee", border: "#28a745", label: "Nouvelle", color: "#187537" },
    updated: { background: "#fff7df", border: "#f0ad00", label: "Modifiée", color: "#8a6500" },
    deleted: { background: "#fdebec", border: "#dc3545", label: "Supprimée", color: "#a51f2d" },
  };
  const pendingStyle = pendingState ? stateStyles[pendingState] : undefined;
  const hasValidDate = noteObj?.createdAt && !isNaN(new Date(noteObj.createdAt).getTime());

  return (
    <div
      className="d-flex align-items-center justify-content-between w-full h-full"
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: "pointer",
        backgroundColor: pendingStyle?.background,
        borderLeft: pendingStyle ? `4px solid ${pendingStyle.border}` : undefined,
        padding: "0 6px",
      }}
    >
      <span className=" w-100 flex items-center justify-center">
        {noteObj && noteObj.value !== "" && noteObj.value !== null && noteObj.value !== undefined ? (
          <>
            <strong className="text-black">{noteObj?.value}</strong>{" "}
            {hasValidDate && (
              <span className="text-gray-200 text-sm">
                ({new Date(noteObj.createdAt)
                .toLocaleDateString("fr-FR", {
                  day: "2-digit",
                  month: "2-digit",
                })
                .replace("/", "-")})
              </span>
            )}
          </>
        ) : (
          <>{pendingState === "deleted" ? "—" : "-"}</>
        )}
        {pendingStyle && (
          <small className="ms-2 fw-semibold" style={{ color: pendingStyle.color }}>
            {pendingStyle.label}
          </small>
        )}
      </span>
      {hovered && (
        <i
          className="fa fa-edit"
          style={{ marginLeft: "8px", color: "#007bff" }}
        />
      )}
    </div>
  );
};

export default EditableCellRenderer;
